class ControlItem {
  constructor(el, root) {
    this.el = el
    this.root = root
    this.type = el.dataset.type
    this.color = this.el.dataset.color
    this.label = el.dataset.label
    this.value = el.dataset.value
    this.disabled = el.dataset.disabled === 'true'
    if (this.type === 'color' || this.type === 'size' || this.type === 'denominations' || this.type === 'metal' || this.type === 'title') {
      this.el.addEventListener('click', this.clickHandler.bind(this))
    }
  }

  clickHandler(event) {
    event.preventDefault()
    this.root.activeItem = this
  }
}

export class ProductControl {
  constructor(el) {
    this.el = el
    this.type = this.el.dataset.type
    this.value = null
    this.items = this.createItems()
    this.input = this.el.querySelector('input')
    this.view = this.el.querySelector('[data-control-current]')
    if (this.items) {
      this.activeItem = this.items.find((item) => !item.disabled)
    }
    if (this.el.dataset.type === 'quantity') {
      this.input.addEventListener('change', () => {
        this.setMeta({
          label: this.input.value
        })
      })
      this.setMeta({
        label: this.input.value
      })
    }
  }

  set activeItem(control) {
    this.items.forEach((ctrl) => ctrl.el.classList.remove('is-active'))
    control.el.classList.add('is-active')
    this.setMeta({
      value: control.value,
      label: control.label
    })
    this.value = control.value
    this._activeItem = control
    if (typeof this.watch === 'function') this.watch()
    if (Array.isArray(this.watch)) this.watch.forEach((watch) => watch())
  }
  get activeItem() {
    return this._activeItem
  }

  setMeta({ value, label }) {
    if (this.input && value) {
      this.input.value = value
      this.input.dispatchEvent(new Event('change', { bubbles: true }))
    }
    if (this.view && label) this.view.textContent = label
  }

  createItems() {
    const items = []
    this.el.querySelectorAll('.product-control-item').forEach((el) => {
      items.push(new ControlItem(el, this))
    })
    return items.length > 0 ? items : null
  }
}
